/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// src/utils/sort.js

export function sortTableData(data, sortColumn, sortOrder) {
  if (!sortColumn) return data;

  // Tüm tarih accessorları
  const dateFields = [
    "satisTarihi",
    "donguTarihi",
    "yeniledigiTarih",
    "abonelikBitis",
    "abonelikBaslangic",
    "kayit_tarihi",
    "updatedAt"
  ];

  return [...data].sort((a, b) => {
    // 1) Tüm tarih field'ları için
    if (dateFields.includes(sortColumn)) {
      const dateA = new Date(a[sortColumn]);
      const dateB = new Date(b[sortColumn]);
      // Geçersiz tarihse en sona atsın
      if (isNaN(dateA)) return 1;
      if (isNaN(dateB)) return -1;
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    }

    // 2) Kalan Abonelik (gün) - kalanGun veya kalan_abonelik accessor'ı için
    if (sortColumn === "kalanGun" || sortColumn === "kalan_abonelik") {
      // kalan_abonelik bir React component olduğu için kalan_gun değerini kullan
      const kalanA = Number(a.kalan_gun || a.kalanGun) || -99999;
      const kalanB = Number(b.kalan_gun || b.kalanGun) || -99999;
      return sortOrder === "asc" ? kalanA - kalanB : kalanB - kalanA;
    }

    // 3) Döngü (sayısal)
    if (sortColumn === "dongu") {
      const donguA = Number(a.dongu) || 0;
      const donguB = Number(b.dongu) || 0;
      return sortOrder === "asc" ? donguA - donguB : donguB - donguA;
    }

    // 4) Hız (sayısal - null/undefined en sonda)
    if (sortColumn === "hiz") {
      const valA = a[sortColumn] != null ? Number(a[sortColumn]) : NaN;
      const valB = b[sortColumn] != null ? Number(b[sortColumn]) : NaN;
      const numA = isNaN(valA) ? (sortOrder === "asc" ? Infinity : -Infinity) : valA;
      const numB = isNaN(valB) ? (sortOrder === "asc" ? Infinity : -Infinity) : valB;
      return sortOrder === "asc" ? numA - numB : numB - numA;
    }

    // 5) Km (odometer) - "12345 km" veya "Veri yok" formatında string gelir
    if (sortColumn === "odometer") {
      const parseKm = (v) => {
        if (v == null || v === "") return NaN;
        if (typeof v === "number") return isNaN(v) ? NaN : v;
        const num = parseFloat(String(v).replace(/[^\d.-]/g, ""));
        return isNaN(num) ? NaN : num;
      };
      const numA = parseKm(a[sortColumn]);
      const numB = parseKm(b[sortColumn]);
      const valA = isNaN(numA) ? (sortOrder === "asc" ? Infinity : -Infinity) : numA;
      const valB = isNaN(numB) ? (sortOrder === "asc" ? Infinity : -Infinity) : numB;
      return sortOrder === "asc" ? valA - valB : valB - valA;
    }

    // 7) String field'lar için
    if (typeof a[sortColumn] === "string" && typeof b[sortColumn] === "string") {
      return sortOrder === "asc"
        ? a[sortColumn].localeCompare(b[sortColumn])
        : b[sortColumn].localeCompare(a[sortColumn]);
    }

    // 8) Sayı ise
    if (
      typeof a[sortColumn] === "number" &&
      typeof b[sortColumn] === "number"
    ) {
      return sortOrder === "asc"
        ? a[sortColumn] - b[sortColumn]
        : b[sortColumn] - a[sortColumn];
    }

    return 0;
  });
}
